import React from "react"
import PropTypes from "prop-types"

import CancelArrow from "./cancel-arrow"
import CashAmount from "./cash-amount"
import CashBalance from "./cash-balance"
import ErrorMessage from "./error-message"
import Keypad from "./keypad"
import NewUser from "./new-user"
import ErrorPopup from "./error-popup"
import Stats from "./stats"
import LoadingSign from "../../components/loading-sign"

const ClockInOut = props => {
  if (props.loading === true) return (<LoadingSign visible={true} />)
  return (props.locationParams.params.locations.length > 0 ? <KeypadPanel {...props} /> : <ErrorPopup {...props} />)
}

const KeypadPanel = props => {
  return (
    <div className="clock-in-panel__main" style={props.clockInOutStyle}>
      <CancelArrow {...props} />
      <div className="clock-in-window">
        <h1>Welcome Back!</h1>
        <div className="clock-in-window__keypad-wrapper">
          {props.errorText && <ErrorMessage text={props.errorText} />}
          <Keypad value={props.currentPin}
            onClickDelete={props.onDeletePinNumber}
            onClickNumber={props.onClickPinNumber}
            onClickStats={props.showStats ? props.onClickStats : null}
            onClickSubmit={props.onSubmitPin}
            showIndicator={!props.errorText}
            submitButtonText={props.keypadButton} />
        </div>
        {props.newUserAllowed &&
          <div className="clock-in-window__divider"><span>or</span></div>}
        {props.newUserAllowed &&
          <button className="clock-in-new-user" onClick={props.onClickNewUser}>Create new user</button>}
      </div>
    </div>
  )
}

const NewUserDone = props => {
  const user = props.newUser || {}
  return (
    <div className="clock-in-panel__info-window new-user-done" style={props.newUserDoneStyle}>
      <div className="clock-in-window">
        <h1>{user.firstName} {user.lastName}'s user successfully created</h1>
        <img src="/images/clock-in/new-user-done.png"/>
        <button onClick={props.onNewUserDone}>Done</button>
      </div>
    </div>
  )
}

const Panel = props => {
  let children = null
  const {isVisible, isCancelling, onClickPanel} = props
  if (isVisible || isCancelling) {
    children = [
      <ClockInOut key="clockInOut" {...props}/>,
      <NewUser key="NewUser" {...props}/>,
      <NewUserDone key="NewUserDone" {...props}/>,
      <CashAmount key="CashAmount" {...props} />,
      <CashBalance key="CashBalance" {...props} />,
      <Stats key="Stats" {...props}/>
    ]
  }
  const style = "ontouchstart" in document.documentElement ? {cursor: "pointer"} : {}
  const panelClass = `clock-in-panel ${isVisible ? "down" : ""}`
  const wrapperClass = `clock-in-panel-wrapper ${isVisible || isCancelling ? "visible" : ""}`
  return (
    <div className={wrapperClass} >
      <div className={panelClass} style={style}
        onClick={onClickPanel} onTouchStart={onClickPanel} >
        {children}
      </div>
    </div>
  )
}

Panel.propTypes = {
  isVisible: PropTypes.bool,
  isCancelling: PropTypes.bool,
  onClickPanel: PropTypes.func
}

export default Panel
